import { createMockListResponse as e } from "../../../helpers/CreateMockListResponse.js";
const a = (t) => ({
  id: `run-${t}`,
  runNumber: t + 1,
  createdOn: "2021-01-01T00:00:00Z",
  createdBy: { userId: `user-${t}`, fullName: `User ${t}` },
  evaluationId: `evaluation-${t}`,
  notes: `Notes for run ${t}`,
  datasetSummary: {
    id: `dataset-${t}`,
    name: `Dataset ${t}`,
    totalQueries: 100 + t
  },
  queryPipelineSummary: {
    id: `pipeline-${t}`,
    name: `Pipeline ${t}`,
    crgaModels: [
      {
        name: "crgamodel",
        passageRelevanceSensitivity: t * 0.15,
        numberOfRankedResultsToConsider: t
      }
    ]
  },
  facets: [],
  customContext: {},
  credentials: {
    type: "ANONYMOUS"
  },
  statistics: {
    startDate: "2021-01-01T00:00:00Z",
    answerRate: 0.5,
    isCompleted: !0
  }
}), s = (t) => ({
  queryId: `query-${t}`,
  query: `Sample query text ${t}`,
  state: "SUCCESS",
  answer: {
    id: `answer-${t}`,
    text: `Sample answer text ${t}`,
    contentFormat: "text/plain",
    citations: [
      {
        id: `citation-${t}`,
        title: `Sample citation title ${t}`,
        uri: `http://example.coveo.com/citation-${t}`,
        permanentId: `permanent-${t}`
      }
    ]
  }
}), o = e(a), c = e(s);
export {
  a as createMockBatchAnswerRunItem,
  s as createMockBatchAnswerRunResultItem,
  c as createMockBatchAnswerRunResultResponse,
  o as createMockBatchAnswerRunsListResponse
};
//# sourceMappingURL=BatchAnswerEvaluationRuns.mocks.js.map
